<script setup lang="ts">
import type { PropType } from 'vue';
import { computed } from 'vue';

import type { FilterTagVariantType } from './FilterTag.model';

const props = defineProps({
  title: { type: String, required: true },
  variant: {
    type: String as PropType<FilterTagVariantType>,
    required: false,
    default: 'default'
  },
  size: {
    type: String as PropType<'sm' | 'lg'>,
    required: false,
    default: 'lg'
  }
});

const containerClsx = computed(() => ({
  'bg-background border': props.variant === 'default',
  'bg-background-main-secondary text-default-lighter': props.variant === 'secondary',
  'p-1 space-x-1': props.size === 'sm',
  'p-2 space-x-2': props.size === 'lg'
}));

const valueClsx = computed(() => ({
  'text-default': props.variant === 'default',
  'bg-background border text-default rounded': props.variant === 'secondary',
  'px-0 py-0': props.size === 'sm',
  'px-2 py-1': props.size === 'lg'
}));
</script>

<template>
  <div class="flex items-center rounded-md w-fit" :class="containerClsx">
    <span class="text-default-disabled text-sm whitespace-nowrap">{{ props.title }}</span>
    <div class="text-sm font-bold" :class="valueClsx">
      <slot />
    </div>
  </div>
</template>
